<template>
	<v-dialog
			content-class="feedbackWrapper"
			:value="true"
			@click:outside="onClose"
			width="500"
	>
		<div class="feedback">
			<div class="actionHeader">
				<span>Feedback</span>
				<v-btn icon color="green" type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</v-btn>
			</div>
			<div class="feedbackBody">
				<div>
					<field
							margin="0 0 10px 0"
							width="320px"
							label="Module"
							placeholder="Select module"
							@updateSelect="onAutocomplete($event, 'module')"
							:autocompleteValue="module"
							:items="selectList"
							:isClearable="false"
							is-select
					></field>
				</div>
				<div>
					<field
							margin="0 0 10px 0"
							width="320px"
							label="Download screenshot"
							placeholder="Add screenshot"
							:setInputValue="file.name"
							@updateFile="onFile($event)"
							is-file
							is-readonly
					></field>
				</div>
				<div>
					<field
							margin="0 0 20px 0"
							width="460px"
							label="Description"
							placeholder="Enter description"
							:setInputValue="description"
							@updateInput="onInput($event, 'description')"
							is-auto-grow
							is-textarea
					></field>
				</div>
			</div>
			<button-groups
					@updateBtnClose="onClose"
					@updateSave="onSave"
					apply-text="Send"
					:preloader="isPreloader"
			></button-groups>
		</div>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups.vue";
import { chaptersList } from "@/shared/HeaderComponent/FeedBack/constants";
import getFlatMap from "@/helper/getFlatMap";

export default {
	name: "FeedBack",
	components: { ButtonGroups },
	computed: mapGetters([ 'permissionsDefault' ]),
	data: () => ({
		isPreloader: false,
		module: '',
		description: '',
		selectList: [],
		file: {
			name: "",
			value: ""
		},
	}),
	methods: {
		...mapActions([ 'onFeedback' ]),
		onClose() {
			this.$emit('updateFeedback');
		},
		async onSave() {
			this.isPreloader = true;
			const { module, description, file } = this.$data;
			await this.onFeedback({ module, description, file });
			this.isPreloader = false;
			this.onClose();
		},
		onAutocomplete({ value }, key) {
			this[key] = value?.text;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onFile(e) {
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.file = {
					name: iFile.name,
					value: reader.result
				};
			};
		},
	},
	mounted() {
		const flatMapPermissions = getFlatMap(this.permissionsDefault);
		console.log('%c [  flatMapPermissions  ] ', 'color:#bada55', typeof flatMapPermissions, flatMapPermissions );
		console.log('%c [  this.permissionsDefault  ] ', 'color:#bada55', typeof this.permissionsDefault, this.permissionsDefault );
		console.log('%c [  chaptersList  ] ', 'color:#bada55', typeof chaptersList, chaptersList );
		this.selectList = chaptersList.filter(item => {
			console.log('%c [  item 4 ] ', 'color:#bada55', typeof item, item );
			const itemDef = flatMapPermissions.find(body => body.name.toLowerCase() === item.value.toLowerCase());
			if (item.isPerm) return true;
			return itemDef?.selected;
		});
	}
};
</script>

<style scoped lang="scss">
.feedbackWrapper {
  .feedback {
    background: var(--card-bg);
    padding: 20px;

    .actionHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      letter-spacing: 0.25px;
      color: var(--card-color);
      margin-bottom: 20px;
    }

    &_text {
      margin-bottom: 20px;
      font-size: 14px;

      &-title {
        font-size: 18px;
        margin-bottom: 10px;
      }
    }
  }
}

[type="button"] {
  line-height: 0;
}
</style>
